<template>
  <nav class="navbar">
    <div class="logo">🇯🇵 Japanese Learning</div>
    <div class="links">
      <router-link to="/">Home</router-link>
      <router-link to="/kana">Kana</router-link>
      <router-link to="/kanji">Kanji</router-link>
      <router-link v-if="token" to="/profile">Profile</router-link>
      <router-link v-if="role === 'admin'" to="/admin" class="admin-link">Admin</router-link>
      <router-link v-if="!token" to="/login">Login</router-link>
      <a v-if="token" @click="logout" href="#">Logout</a>
    </div>
  </nav>
  <router-view class="container" />
</template>

<script setup>
import { ref } from 'vue';

const token = ref(localStorage.getItem('token'));
const role = ref(localStorage.getItem('role'));

function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  localStorage.removeItem('role');
  token.value = null;
  role.value = null;
  window.location.href = '/login'; 
}
</script>

<style>
body {
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f0f2f5;
}
.navbar {
  background: #2a3a4a;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.logo {
  font-weight: bold;
  font-size: 1.2rem;
}
.links a {
  color: #ccc;
  text-decoration: none;
  margin-left: 1.5rem;
  font-weight: 500;
  transition: color 0.2s;
}
.links a:hover, .links a.router-link-active {
  color: #fff;
}
.admin-link {
  color: #fbbf24 !important;
  font-weight: bold;
}
.container {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
</style>
